export const STREAM_TABS = [
  "edit",
  "broadcast",
  "restream",
  "studio",
  "monitoring",
  "polls",
] as const;

export type StreamTab = (typeof STREAM_TABS)[number];

// Значения формы вкладки «Редактирование» (react-final-form) — 1:1 ложатся
// в UpdateStreamInput (см. StreamEditTab.tsx).
export interface StreamFormValues {
  title: string;
  description: string | null;
  startAt: string | null;
  publishAt: string | null;
  accessStartAt: string | null;
  previewId: string | null;
  verticalPreviewId: string | null;
  tagIds: string[];
  productIds: string[];
  widgetId: string | null;
  ageRestrictions: number;
  hideInGeneralLists: boolean;
  onlyUsers: boolean;
  enableRecord: boolean;
  autoPublishRecord: boolean;
  isChatEnabled: boolean;
  dvrEnabled: boolean;
}
